// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","header":"header-37SeL","icon":"icon-2IsTP","button":"button-1CrXh"};